import gql from 'graphql-tag';
import authFragment from './fragments/authFragment';

export default gql`
  ${authFragment}
  mutation createMember(
    $email: String!
    $firstName: String
    $surname: String
    $password: String
    $promoCode: String
    $cityId: Int
    $termsAndPrivacy: Boolean
    $contactPermission: Boolean
    $phoneNumber: String
    $siteId: Int
    $suburbIds: [Int]
    $SignupSource: String
    $SignupMedium: String
    $SignupCampaign: String
  ) {
    createEmailMember(
      email: $email
      firstName: $firstName
      surname: $surname
      password: $password
      promoCode: $promoCode
      cityId: $cityId
      termsAndPrivacy: $termsAndPrivacy
      contactPermission: $contactPermission
      phoneNumber: $phoneNumber
      siteId: $siteId
      suburbIds: $suburbIds
      SignupSource: $SignupSource
      SignupMedium: $SignupMedium
      SignupCampaign: $SignupCampaign
    ) {
      ...authFragment
    }
  }
`;
